<template>
  <JtMenu
    :links="computedItems"
    :config="menuConfig"
    class="menu overflow-hidden"
    @click.native="onClick"
  />
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtMenu } from 'jtech-webcomps'
@Component({
  components: {
    JtMenu
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
})
export default class SideMenu extends Vue {
  menuConfig = {
    contracted:
      '<i class="fa-xs fa fa-chevron-down text-light border-1 pl-1 pr-1"></i>',
    expanded:
      '<i class="fa-xs fa fa fa-chevron-up text-light pl-1 pr-1"></i>',
    labelName: 'name',
    nodeName: 'children',
    expandFlagName: 'expanded',
    enableSearch: true
  };

  get computedItems () {
    const items = []
    return [
      ...items,
      ...this.items
    ]
  }
}
</script>

<style>
.menu .q-item {
  padding: 0px;
}

.menu .icon-search {
  padding: 0px 20px;
}

.child-container {
  padding-left: 10px;
  background-color: #394053;
}

.scroll-area-menu {
  background-color: #394053;
}

.pd-menu {
  padding: 13px 15px 10px 30px;
  border-bottom: 1px solid rgb(255 255 255 / 25%);
  margin: 0px 10px;
}

.item-link {
  padding: 5px 10px 5px 40px !important;
  border-bottom: 1px solid rgb(255 255 255 / 0.25);
  margin: 0px 10px 0px 0px;
}
</style>
